import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { STACK } from "@/data/content";

export const Stack = () => {
  return (
    <section id="stack" className="relative border-t border-[#1A1A20] bg-[#050505]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-5 lg:gap-16">
          <div className="lg:col-span-2">
            <SectionHeading number="02" label="Stack" title="Arsenal" accent="técnico." />
            <Reveal delay={0.15}>
              <p className="mt-6 text-sm leading-relaxed text-zinc-500 sm:text-base">
                Ferramentas escolhidas por performance, não por moda. Cada tecnologia aqui já entregou
                resultado em projetos reais — de landing pages corporativas a portais de eSports.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-8 flex flex-wrap gap-2">
                {["TypeScript", "Vite", "Git", "Figma", "Vercel", "MongoDB", "PostgreSQL", "REST & GraphQL"].map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-[#22222A] bg-[#0A0A0C] px-3.5 py-1.5 font-mono-code text-[10px] uppercase tracking-widest text-zinc-400 transition-colors duration-300 hover:border-[#E50914]/50 hover:text-zinc-100"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2 lg:col-span-3">
            {STACK.map((skill, i) => (
              <Reveal key={skill.name} delay={i * 0.06} y={24}>
                <div data-testid={`stack-skill-${skill.name.toLowerCase().replace(/[^a-z0-9]/g, "")}`} className="group">
                  <div className="flex items-end justify-between">
                    <div>
                      <span className="font-display text-base font-bold text-zinc-100">{skill.name}</span>
                      <span className="ml-3 font-mono-code text-[10px] uppercase tracking-widest text-zinc-600">
                        {skill.tag}
                      </span>
                    </div>
                    <span className="font-mono-code text-xs text-[#E50914]">{skill.level}%</span>
                  </div>
                  <div className="mt-3 h-[3px] w-full overflow-hidden rounded-full bg-[#1A1A20]">
                    <motion.div
                      initial={{ scaleX: 0 }}
                      whileInView={{ scaleX: 1 }}
                      viewport={{ once: true, margin: "-40px" }}
                      transition={{ duration: 1.2, delay: 0.1 + i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                      style={{ width: `${skill.level}%` }}
                      className="h-full origin-left rounded-full bg-gradient-to-r from-[#8A0810] to-[#E50914] shadow-[0_0_12px_rgba(229,9,20,0.5)]"
                    />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
